
interface CallbackStatusMessageProps {
  status: 'processing' | 'success' | 'error';
  details: string;
}

export const CallbackStatusMessage = ({ status, details }: CallbackStatusMessageProps) => {
  if (!details) return null;

  const styles = {
    success: 'bg-green-50 text-green-700 border border-green-200',
    error: 'bg-red-50 text-red-700 border border-red-200',
    processing: 'bg-blue-50 text-blue-700 border border-blue-200'
  };

  return (
    <div className={`p-3 rounded-md text-sm ${styles[status]}`}>
      {details}
    </div>
  );
};
